import { useState } from 'react'
import { ScoopButton, ScoopSpinner, ScoopTextField } from '../../../ui'
import { EnvelopeIcon } from '@phosphor-icons/react'
import styles from './VerifyEmail.module.scss'

export const VerifyEmail = ({
    signUpUser,
    isSignUpLoading,
    handleConfirmSignup,
    handleResendCode,
}) => {
    const [verificationCode, setVerificationCode] = useState('')

    // Defensive: ensure signUpUser and email exist
    const email = signUpUser?.email || ''

    const handleRequestNewCode = () => {
        setVerificationCode('')
        handleResendCode()
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (verificationCode && verificationCode.length === 6) {
            handleConfirmSignup(verificationCode)
        }
    }

    return (
        <div className={styles.signupContainer}>
            <div className={styles.formHeader}>
                <div className={styles.emailIconWrapper}>
                    <EnvelopeIcon size={32} weight="regular" />
                </div>
                <h2>Verify your email</h2>
                <p>
                    We sent a code to
                    <br />
                    <span className={styles.emailHighlight}>{email}</span>
                    <br />
                    Enter below to verify your account
                </p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Verification Code"
                        type="text"
                        id="verificationCode"
                        name="verificationCode"
                        placeholder="Enter 6 digit code"
                        value={verificationCode}
                        onChange={(e) => setVerificationCode(e.target.value)}
                        disableMargin
                        maxLength={6}
                    />
                </div>

                <ScoopButton
                    variant="default"
                    size="fullWidth"
                    type="submit"
                    disabled={!verificationCode || verificationCode.length !== 6 || isSignUpLoading}
                >
                    {isSignUpLoading ? <ScoopSpinner /> : 'Submit code'}
                </ScoopButton>

                <div className={styles.helpText}>
                    Don't see an email?
                    <br />
                    Check your spam folder or
                    <span className={styles.linkText} onClick={handleRequestNewCode}>
                        {' '}
                        request new code
                    </span>
                </div>
            </form>
        </div>
    )
}
